import { useCallback, useState } from 'react';

export const useSuggestions = (
	items,
	extractValue = item => item,
	{minSearchLength = 1} = {}
) => {
	const [suggestions, setSuggestions] = useState([]);
	const [showSuggestions, setShowSuggestions] = useState(false);

	const updateSuggestions = (inputValue) => {
		const searchTerm = inputValue.toLowerCase().trim();
		const normalizeValue = (value) => String(value ?? "");
		const filteredItems = items.filter((item) =>
			normalizeValue(extractValue(item)).toLowerCase().includes(searchTerm)
		);

		const seen = new Set();
		const updated = [inputValue, ...filteredItems.map((item) => normalizeValue(extractValue(item)))]
			.filter((value) => {
				const key = value.toLowerCase();
				if (seen.has(key)) return false;
				seen.add(key);
				return true;
			});

		setSuggestions(updated);
		setShowSuggestions(searchTerm.length >= minSearchLength && filteredItems.length > 0);
	};

	const hideSuggestions = useCallback(() => setShowSuggestions(false), []);

	return {
		suggestions,
		showSuggestions,
		updateSuggestions,
		hideSuggestions,
		setShowSuggestions
	};
};
